/**
 * Admin Clients API Service
 * Frontend API calls for client management
 */

import axios from 'axios';

const API_URL = '/api/admin/clients';

export const clientsAdminService = {
    /**
     * Create new client
     * @param {Object} data - { workspaceName, domain, adminEmail }
     * @returns {Promise}
     */
    createClient: (data) => 
        axios.post(`${API_URL}`, data),

    /**
     * Get all clients with pagination
     * @param {Object} params - { page, limit, search, status }
     * @returns {Promise}
     */
    getAllClients: (params = {}) => 
        axios.get(`${API_URL}`, { params }),

    /**
     * Get single client by ID
     * @param {number} clientId
     * @returns {Promise}
     */
    getClientById: (clientId) => 
        axios.get(`${API_URL}/${clientId}`),

    /**
     * Update client information
     * @param {number} clientId
     * @param {Object} data - Fields to update
     * @returns {Promise}
     */
    updateClient: (clientId, data) => 
        axios.put(`${API_URL}/${clientId}`, data),

    /**
     * Delete client
     * @param {number} clientId
     * @returns {Promise}
     */
    deleteClient: (clientId) => 
        axios.delete(`${API_URL}/${clientId}`),

    /**
     * Approve a free trial waiting for approval (K11): switches it on, starts its days and sends the invitation
     * @param {number} clientId
     * @returns {Promise}
     */
    approveTrial: (clientId) =>
        axios.post(`${API_URL}/${clientId}/approve`),

    /**
     * Verify client activation with token
     * @param {string} token - Activation token from email
     * @returns {Promise}
     */
    verifyActivation: (token) => 
        axios.post(`${API_URL}/verify-activation/${token}`),

    /**
     * Check if domain is available
     * @param {string} domain
     * @returns {Promise<boolean>}
     */
    checkDomainAvailability: async (domain) => {
        try {
            // This is a helper function - you may implement this via a dedicated endpoint
            // or check during form submission
            const response = await axios.get(`${API_URL}?search=${domain}`);
            const exists = response.data.data.some(client => client.domain === domain.toLowerCase());
            return !exists;
        } catch (error) {
            console.error('Error checking domain availability:', error);
            return false;
        }
    },

    generateUniqueSlug: (workspace) =>axios.post(`${API_URL}/generate-slug`, { workspaceName: workspace }),

    /**
     * Resend activation email to admin
     * @param {number} clientId
     * @returns {Promise}
     */
    // POST (K13 pt 10). Removed 12 Oct 2026 (K13 pt 10): calling it with GET.
    resendActivationEmail: (clientId) => 
        axios.post(`${API_URL}/send-invite/${clientId}`),

    /**
     * Get activation status for a client
     * @param {number} clientId
     * @returns {Promise}
     */
    getActivationStatus: (clientId) => 
        axios.get(`${API_URL}/activation-status/${clientId}`),
    

    /**
     * Get admin user for a client
     * @param {number} clientId
     * @returns {Promise}
     */
    getClientAdmin: (clientId) => 
        axios.get(`${API_URL}/${clientId}/admin`),
    };

export default clientsAdminService;
